import { useMemo } from "react";
import useSWR from "swr";

import { apiUsersEndpoints } from "@api/Endpoints";

import { fetcher } from "@utils/swrUtils";

import { ApiSecretsResponse } from "../models/api-secrets-models";

export function useGetApiSecrets() {
  const url = apiUsersEndpoints.secretsList();

  const { data, error, isLoading } = useSWR<ApiSecretsResponse, Error>(
    url,
    fetcher,
    { revalidateOnFocus: false }
  );

  return useMemo(
    () => ({ apiSecrets: data?.apiSecrets, isLoading, error }),
    [data, isLoading, error]
  );
}
